import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

// @ts-ignore
import AddOnSliderCard from '@/components/Billing/AddOns/AddOnSliderCard.vue';
import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingSectionHeader from '@/components/Billing/BillingSectionHeader.vue';
import BillingService from '@/components/Billing/billing-service';
import { SECTION_DESCRIPTION, HOW_IT_WORKS_EXPLANATIONS, LEARN_MORE_LINK } from '@/components/Billing/billing-service.const';
import { ProductType } from '@/components/Billing/billing-types';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingAutomationSlider',
  props: {
    currentQuantity: null
  },
  emits: ["update-amount"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update-amount', usageLimit: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	currentQuantity: number;
}



const { useProduct, billingPeriod } = useBilling();
const productType = ProductType.Automation;
const subTitle = computed(() => SECTION_DESCRIPTION[productType]);
const learnMoreLink = computed(() => LEARN_MORE_LINK[productType]);
const howItWorksExplanations = computed(() => HOW_IT_WORKS_EXPLANATIONS[productType]);
const automationProduct = computed(() => useProduct.value(productType));
const automationSliderValue = ref(props.currentQuantity);
const automationPriceMap = computed(() =>
	BillingService.buildSliderPriceMap(automationProduct.value, billingPeriod.value, props.currentQuantity)
);
const seeAutomationPriceMap = () => {
	AppDialogManagerService.openBillingPriceMapDialog({ title: 'Automation price list', priceMap: automationPriceMap.value });
};
const onSliderUpdated = (newV: number) => {
	automationSliderValue.value = newV;
	emit('update-amount', newV);
};

return { __sfc: true,emit, props, useProduct, billingPeriod, productType, subTitle, learnMoreLink, howItWorksExplanations, automationProduct, automationSliderValue, automationPriceMap, seeAutomationPriceMap, onSliderUpdated, AddOnSliderCard, BillingSectionHeader }
}

})